export function lineCircleIntersection(sPoint, ePoint, center, radius, angleFrom = 0, angleTo = 2 * Math.PI) {
    const lineVec = ePoint.subtract(sPoint);
    lineVec.normalize(1);
    const circleVec = sPoint.subtract(center);
    const wl = Math.sqrt(circleVec.x * circleVec.x + circleVec.y * circleVec.y);
    const vc = { x: -circleVec.x / wl, y: -circleVec.y / wl };
    // only if ray is pointing to circle
    if (lineVec.dot(vc) < 0) {
        return null;
    }
    const Ap = lineVec.x * lineVec.x + lineVec.y * lineVec.y;
    const Bp = -2 * (lineVec.x * circleVec.x + lineVec.y * circleVec.y);
    const Cp = circleVec.x * circleVec.x + circleVec.y * circleVec.y - radius * radius;
    const discriminant = Bp * Bp - 4 * Ap * Cp;
    if (discriminant < 0) {
        return null;
    }
    const t1 = (Bp + Math.sqrt(discriminant)) / (2 * Ap);
    const t2 = (Bp - Math.sqrt(discriminant)) / (2 * Ap);
    const t = Math.max(t1, t2);
    const result = {
        x: sPoint.x + t * lineVec.x,
        y: sPoint.y + t * lineVec.y,
    };
    const atan2 = Math.atan2(result.y - center.y, result.x - center.x);
    if (atan2 >= angleFrom && atan2 <= angleTo) {
        return result;
    }
    return null;
}
